import { createContext } from "react";

export const cvCon = createContext();